import React from 'react';
import Server from 'data/Server';
import { Redirect, withRouter } from 'react-router';


const _PREFIX = '/_l/';


class Limbo extends React.Component {

  constructor() {
    super();
    this.state = { ready: false };
    this.server = new Server.Factory().create();
    this.server.listenForInitialData(this.onInitialDataLoaded.bind(this));
  }

  onInitialDataLoaded() {
    if (this.server.isInitialDataLoaded()) {
      this.setState({ ready: true });
    }
  }

  render() {
    if (this.state.ready) {
      let encodedDestination = this.props.location.search.substr(1);
      let decodedDestination = Limbo.unwrap(encodedDestination);
      if (this.server.user_email()) {
        return <Redirect to={decodedDestination} />;
      } else {
        return <Redirect to={`/login?then=${encodedDestination}`} />;
      }
    }

    return <div className='section'>Wait...</div>;
  }

  static prefix() {
    return _PREFIX;
  }

  static wrap(path) {
    return _PREFIX + '?' + encodeURIComponent(path);
  }

  static unwrap(path) {
    return decodeURIComponent(path.replace(_PREFIX + '?', ''));
  }
}


export default withRouter(Limbo);
